import mealDetailsQuery from './mealDetailsQuery.graphql';
import checkErrors from '../checkErrors';
import { createError } from '../createError';
import createVariables from './createVariables';

const hasResults = data => data != null;

const fetchData = ({ client, location }) => {
    return resultsFetchData({ resultsQuery: mealDetailsQuery })({ client, location });
};

const slugRegex = /^(?:.*[-/])?([a-zA-Z0-9-_]+)$/;

const extractMealId = (pathname) => {
    const matched = slugRegex.exec(pathname);
    return matched ? matched[1] : null;
}

const resultsFetchData = ({ resultsQuery }) => ({ client, location, fetchPolicy = 'cache-first' }) => {
    const { pathname, search, query } = location;
    const mealId = extractMealId(pathname);

    const searchParams = {
        mealId
    }

    return client
        .query({
            query: resultsQuery,
            variables: createVariables(searchParams),
            fetchPolicy
        })
        .then((result) => {
            // Handle GraphQL errors that come with data
            if (result.errors && result.errors.length > 0) {
                console.error('GraphQL errors:', result.errors);
                // Return data even with errors so we can show a proper error message
                return {
                    data: result.data,
                    error: {
                        type: 'graphql',
                        message: 'Unable to load meal details. Please try again later.',
                        details: result.errors
                    }
                };
            }
            return checkErrors(hasResults)(result);
        })
        .catch((error) => {
            console.error('Network or other error:', error);
            // Return error state instead of throwing
            return {
                data: null,
                error: {
                    type: 'network',
                    message: 'Unable to connect to the server. Please check your connection and try again.',
                    details: error
                }
            };
        });
};

export default fetchData;
